import { render } from "./ChapterButton.vue?vue&type=template&id=bb2b1f3c"
import script from "./ChapterButton.vue?vue&type=script&lang=js"
export * from "./ChapterButton.vue?vue&type=script&lang=js"
script.render = render

export default script